// src/components/subscriptions.js

import axios from 'axios';

/**
 * Crea una nuova subscription in Stripe + Strapi
 * Restituisce un oggetto con { data: { localSubscriptionId, clientSecret } }
 */
export function createSubscription({
  userId,
  tierId,
  stripeCustomerId,
  stripePriceId,
  metadata = {},
}) {
  return axios.post(
    '/api/subscriptions/create',
    { userId, tierId, stripeCustomerId, stripePriceId, metadata },
    {
      headers: { 'Content-Type': 'application/json' },
      withCredentials: true,
    }
  );
}

/**
 * Conferma la subscription dopo che il pagamento è andato a buon fine
 */
export function confirmSubscription({ localSubscriptionId, paymentIntentId }) {
  return axios.post(
    '/api/subscriptions/confirm',
    { localSubscriptionId, paymentIntentId },
    {
      headers: { 'Content-Type': 'application/json' },
      withCredentials: true,
    }
  );
}

/**
 * Recupera tutte le subscription dell’utente autenticato via Strapi
 */
export function fetchSubscriptions() {
  return axios.get('/api/subscriptions', {
    headers: { 'Content-Type': 'application/json' },
    withCredentials: true,
  });
}

/**
 * Annulla la subscription a fine periodo
 */
export function cancelSubscription({ localSubscriptionId }) {
  return axios.post(
    '/api/subscriptions/cancel',
    { localSubscriptionId },
    {
      headers: { 'Content-Type': 'application/json' },
      withCredentials: true,
    }
  );
}

/**
 * Recupera le subscription dell’utente da Strapi (ex-fetchStripeSubscriptions)
 */
export function fetchGlobalSubscriptions() {
  return axios.get('/api/subscriptions/stripe', {
    headers: { 'Content-Type': 'application/json' },
    withCredentials: true,
  });
}

/**
 * Recupera i dettagli di una singola subscription Stripe
 */
export const fetchStripeSubscriptionDetails = (subscriptionId) =>
  axios.get(`/api/subscriptions/stripe/${subscriptionId}`, {
    headers: { 'Content-Type': 'application/json' },
    withCredentials: true,
  });

export function fetchSubscriptionTiers() {
  return axios.get('/api/subscription-tiers', {
    headers: { 'Content-Type': 'application/json' },
    withCredentials: true,
  });
}
